<template>
  <div class="stencil-container container-box">
    <div class="search-box">
      <a-input-search
        v-model:value="searchStencilName"
        placeholder="组件搜索"
        @search="onStencilSearch"
      />
    </div>
    <perfect-scrollbar-container
      ref="perfectScrollbarRef"
      width="100%"
      height="calc(100% - 66px)"
    >
      <template #container>
        <div class="stencil-group-list">
          <div
            class="stencil-group"
            v-for="group in stencilGroups"
            :key="group.groupKey"
          >
            <div
              :class="{
                'stencil-group-head': true,
                'stencil-group-head-close':
                  stencilGroupCollapseCloseStatus[group.groupKey],
              }"
              @click="
                changeStencilGroupCollapseCloseStatus(
                  group.groupKey,
                  stencilGroupCollapseCloseStatus[group.groupKey]
                )
              "
            >
              <div class="stencil-group-name">{{ group.groupName }}</div>
              <DownOutlined
                :class="{
                  'arrow-rotate-right':
                    stencilGroupCollapseCloseStatus[group.groupKey],
                }"
              />
            </div>
            <div
              :class="{
                'stencil-grid': true,
                'stencil-grid-close':
                  !!stencilGroupCollapseCloseStatus[group.groupKey],
              }"
            >
              <stencil-item
                v-for="stencil in group.stencilsList"
                :key="stencil.stencilName"
                :stencil="stencil"
              />
            </div>
          </div>
        </div>
      </template>
    </perfect-scrollbar-container>
  </div>
</template>

<script>
import interact from "interactjs";
import * as R from "ramda";
import { DownOutlined } from "@ant-design/icons-vue";
import { getStencils, groupInfoObj } from "@/stencils/index";
import StencilItem from "./StencilItem";

import PerfectScrollbarContainer from "@/components/PerfectScrollbar";

const stencils = getStencils();

const getGroupsList = (searchName) => {
  const groupsList = [];
  for (let [groupKey, group] of Object.entries(stencils)) {
    const tmp = {
      groupKey,
      groupName: groupInfoObj[groupKey].name,
      sortNo: groupInfoObj[groupKey].sortNo,
    };
    const stencilsList = [];
    for (let [stencilKey, stencil] of Object.entries(group)) {
      if (!searchName) {
        stencilsList.push({
          groupKey,
          stencilKey,
          stencil,
        });
      } else {
        const regxp = new RegExp(searchName);
        if (regxp.test(stencil.stencilName)) {
          stencilsList.push({
            groupKey,
            stencilKey,
            stencil,
          });
        }
      }
    }
    stencilsList.sort((a, b) => a.stencil.sortNo - b.stencil.sortNo);
    tmp.stencilsList = stencilsList;
    if (tmp.stencilsList.length) groupsList.push(tmp);
  }

  groupsList.sort((a, b) => a.sortNo - b.sortNo);

  return groupsList;
};

export default {
  name: "StencilContainer",
  components: {
    DownOutlined,
    StencilItem,
    PerfectScrollbarContainer,
  },
  data() {
    return {
      searchStencilName: "",
      dropBoxPosition: { x: 0, y: 0 },
      stencilGroups: getGroupsList(),
      stencilGroupCollapseCloseStatus: {},
    };
  },
  mounted() {
    this.initDrop();
    this.initDropzone();
  },
  methods: {
    changeStencilGroupCollapseCloseStatus(key, state) {
      if (state) this.removeStencilGroupCollapseCloseStatus(key);
      else this.addStencilGroupCollapseCloseStatus(key);
      this.$nextTick(() => {
        this.$refs.perfectScrollbarRef.update();
      });
    },
    addStencilGroupCollapseCloseStatus(key) {
      const stencilGroupCollapseCloseStatusClone = R.clone(
        this.stencilGroupCollapseCloseStatus
      );
      stencilGroupCollapseCloseStatusClone[key] = true;
      this.stencilGroupCollapseCloseStatus =
        stencilGroupCollapseCloseStatusClone;
    },
    removeStencilGroupCollapseCloseStatus(key) {
      const stencilGroupCollapseCloseStatusClone = R.clone(
        this.stencilGroupCollapseCloseStatus
      );
      delete stencilGroupCollapseCloseStatusClone[key];
      this.stencilGroupCollapseCloseStatus =
        stencilGroupCollapseCloseStatusClone;
    },
    onStencilSearch(searchName) {
      this.stencilGroups = getGroupsList(searchName);
      this.stencilGroupCollapseCloseStatus = {};
      this.$nextTick(() => {
        this.$refs.perfectScrollbarRef.update();
      });
    },
    initDrop() {
      interact(".drop-box").draggable({
        listeners: {
          start: (event) => {
            const target = event.target;
            const position = this.dropBoxPosition;
            const domRect = target.getBoundingClientRect();

            position.x += domRect.x;
            position.y += domRect.y;

            this.dropBoxPosition = R.clone(position);

            target.style.position = "fixed";
            target.style.transform = `translate(${position.x}px, ${position.y}px)`;
          },
          move: (event) => {
            const target = event.target;
            const position = this.dropBoxPosition;

            position.x += event.dx;
            position.y += event.dy;

            this.dropBoxPosition = R.clone(position);

            target.style.transform = `translate(${position.x}px, ${position.y}px)`;
          },
          end: (event) => {
            const target = event.target;
            target.style.transform = "";
            target.style.position = "absolute";
            this.dropBoxPosition = { x: 0, y: 0 };
          },
        },
      });
    },
    initDropzone() {
      const addEl = (position, createCell, cb) => {
        this.$joint.addEl(position, createCell);
        this.$nextTick(() => {
          cb instanceof Function && cb();
        });
      };
      interact("#joint-paper-container").dropzone({
        ondragenter: () => {},
        ondrop: (event) => {
          const target = event.target;
          const targetDomRect = target.getBoundingClientRect();

          const pageScrollerDom = target.parentElement.parentElement;
          const pageScrollerDomRect = pageScrollerDom.getBoundingClientRect();

          const relatedTarget = event.relatedTarget;
          const relatedTargetDomRect =
            event.relatedTarget.getBoundingClientRect();

          const stencilKey = relatedTarget.getAttribute("data-stencilkey");
          const groupkey = relatedTarget.getAttribute("data-groupkey");

          const checkIsInPageScroller = () => {
            let isInXRange = false;
            let isInYRange = false;

            if (
              relatedTargetDomRect.x >= pageScrollerDomRect.x &&
              relatedTargetDomRect.x <= pageScrollerDomRect.right
            ) {
              isInXRange = true;
            }

            if (
              relatedTargetDomRect.y >= pageScrollerDomRect.y &&
              relatedTargetDomRect.y <= pageScrollerDomRect.bottom
            ) {
              isInYRange = true;
            }

            return Boolean(isInXRange && isInYRange);
          };

          if (checkIsInPageScroller()) {
            addEl(
              {
                x: relatedTargetDomRect.x - targetDomRect.x,
                y: relatedTargetDomRect.y - targetDomRect.y,
              },
              stencils[groupkey][stencilKey].createCell
            );
          }
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/theme.less";

.stencil-container {
  width: 200px;
  height: 100%;
  background-color: #ffffff;
  border-radius: 10px;
  > .search-box {
    width: 100%;
    padding: 16px;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
    > .ant-input-search {
      border-radius: 5px;
    }
  }
}

.stencil-group-list {
  width: 100%;
  min-height: 100%;
  border-radius: 0 0 10px 10px;
  > .stencil-group {
    width: 100%;
    &:not(:last-of-type) {
      border-bottom: 1px solid darken(@primary-color, 80%);
    }
    > .stencil-group-head {
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      background-color: @primary-color;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.3s;
      > .anticon-down {
        transition: all 0.2s;
      }
      > .arrow-rotate-right {
        transform: rotate(-90deg);
      }
    }
    > .stencil-group-head-close {
      background-color: transparent;
    }
    > .stencil-grid {
      width: 100%;
      padding: 16px 16px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-auto-rows: 32px;
      gap: 10px 10px;
      transition: all 0.2s;
    }
    > .stencil-grid-close {
      height: 0px;
      padding: 0 16px;
      overflow: hidden;
    }
  }
}
</style>
